import { FunctionComponent } from 'react';
import {
  CheckCircleOutlineRounded,
  ErrorOutlineRounded,
  ReportProblemRounded
} from '@material-ui/icons';
import contentStyles from 'styles/statusIcon';
import clsx from 'clsx';

interface IconI {
  status: 'success' | 'warning' | 'error' | 'default';
}

const BooleanIcon: FunctionComponent<IconI> = ({ status }: IconI) => {
  const classes = contentStyles();

  const icon = () => {
    switch (status) {
      case 'success': {
        return (
          <CheckCircleOutlineRounded
            className={clsx(classes.icon, classes.success)}
          />
        );
      }

      case 'warning': {
        return (
          <ReportProblemRounded
            className={clsx(classes.icon, classes.warning)}
          />
        );
      }

      case 'error': {
        return (
          <ErrorOutlineRounded className={clsx(classes.icon, classes.error)} />
        );
      }

      default: {
        return (
          <ReportProblemRounded
            className={clsx(classes.icon, classes.success)}
          />
        );
      }
    }
  };

  return <>{icon()}</>;
};

export default BooleanIcon;
